import state from './module-abbreviation-setup-state';
import mutations from './module-abbreviation-setup-mutations';
import actions from './module-abbreviation-setup-actions';
import getters from './module-abbreviation-setup-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
